// extracted by mini-css-extract-plugin
export default {"mainDiv":"TextAndData_mainDiv__wtAvZ","dateDiv":"TextAndData_dateDiv__L6AOT"};